import { LinkType } from './enums';

export const MARKET_PLACE_USER_LOGGED_IN = 'marketplace_user_logged_in';
export const USER_ACCESS_TOKEN = 'user_access_token';
export const LAST_PATHNAME = 'last_path';
export const SELECTED_USER_ORG_ID = 'selected_org';
export const SELECTED_USER_TEAM_ID = 'selected_team';
export const INTERNAL_APP_HOSTING_LINKS = [LinkType.USER_GUIDE_URL];
export const EXTERNAL_APP_HOSTING_LINKS = [
  LinkType.SERVER_URL,
  LinkType.UI_HOME_URL,
  LinkType.USER_GUIDE_URL,
];
